import React from "react";
import { StyleSheet, css } from "aphrodite";
import FamilyImage from "../../assets/consult/consult-booked-illustration.png";
import Flex from "../core/Flex";
import Text from "../core/Text";
import useCareScreenerWidth from "../../hooks/care-screener/useCareScreenerWidth";

export const CARE_TEAM_FOLLOW_UP_TITLE = "Your account is ready";
export const CARE_TEAM_FOLLOW_UP_BODY =
  "We could not finish connecting your family to our care records automatically, so a member of our care team will complete your setup and reach out to you to schedule.";
export const CARE_TEAM_FOLLOW_UP_NEXT =
  "There is nothing else you need to do right now. Please do not submit this form again.";

export default function CareTeamFollowUp() {
  const { widthStyle } = useCareScreenerWidth();
  return (
    <Flex center className={css(styles.container)} style={widthStyle}>
      <img src={FamilyImage} className={css(styles.image)} alt="" />
      <Text title center>
        {CARE_TEAM_FOLLOW_UP_TITLE}
      </Text>
      <Text center style={{ marginTop: 20 }}>
        {CARE_TEAM_FOLLOW_UP_BODY}
      </Text>
      <Text center weight={700} style={{ marginTop: 20 }}>
        {CARE_TEAM_FOLLOW_UP_NEXT}
      </Text>
      <Text center style={{ marginTop: 20 }}>
        Questions? Email support@getmanatee.com.
      </Text>
    </Flex>
  );
}

const styles = StyleSheet.create({
  container: {
    padding: 20
  },
  image: {
    width: "100%",
    maxWidth: 260,
    objectFit: "contain"
  }
});
